import { render } from "./newcarduser.vue?vue&type=template&id=2211d392&scoped=true"
import script from "./newcarduser.vue?vue&type=script&lang=js"
export * from "./newcarduser.vue?vue&type=script&lang=js"

import "./newcarduser.vue?vue&type=style&index=0&id=2211d392&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2211d392"]])

export default __exports__